import { render, staticRenderFns } from "./soilSampleBox.vue?vue&type=template&id=b1b0d322&scoped=true"
import script from "./soilSampleBox.vue?vue&type=script&lang=js"
export * from "./soilSampleBox.vue?vue&type=script&lang=js"
import style0 from "./soilSampleBox.vue?vue&type=style&index=0&id=b1b0d322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b0d322",
  null
  
)

export default component.exports